<template>
  <main class="items">
    <div class="items__selectBlock" v-if="!itemsFind">
      <div class="items__select" @click="openSelectAction">
        <p>{{ selected }}</p>
        <img :class="{ rotate: selectOpen }" src="../../assets/images/down-arrow.svg" alt="open" />
      </div>
      <div class="items__select__dropDown" v-if="selectOpen">
        <span
          class="items__select__dropDown__item"
          v-for="item in selectItems"
          v-if="selected !== item"
          @click="selectedAction(item)"
        >
          {{ item }}
        </span>
      </div>
      <div class="items__input" v-if="selected === selectItems[0]">
        <input type="text" v-model="userId" placeholder="User Id у кого забирать" />
      </div>
      <button
        class="items__btn"
        :class="{ disable: !userId.length || disableBtn }"
        v-if="selected === selectItems[0]"
        @click="findUserInventory"
      >
        Найти
      </button>
      <div class="items__input" v-if="selected === selectItems[1]">
        <input type="text" v-model="userId" placeholder="User Id у кого забрать" />
      </div>
      <button
        class="items__btn"
        :class="{ disable: !userId.length || disableBtn }"
        v-if="selected === selectItems[1]"
        @click="findUserInventory"
      >
        Найти
      </button>
      <div class="items__input" v-if="selected === selectItems[2]">
        <input type="text" v-model="userId" placeholder="User Id кому выдать" />
      </div>
      <button
        class="items__btn"
        :class="{ disable: !userId.length || disableBtn }"
        v-if="selected === selectItems[2]"
        @click="findAllItems"
      >
        Найти все вещи
      </button>
      <p class="items__error" v-if="errorMsg">Ошибка</p>
      <div class="items__loader" v-if="loader">
        <Loader />
      </div>
    </div>
    <div v-if="itemsFind" class="items__head">
      <div class="items__headLeftBlock">
        <div class="items__headArrow" @click="backToFind">
          <img src="../../../src/assets/images/arrowLeft.svg" alt="arrowLeft" />
          <p>Вернуться на поиск</p>
        </div>
        <div class="checkbox" v-if="this.selected === this.selectItems[1]">
          <span :class="{ active: selectAll }" @click="selectAllCheckbox"
            >Выбрать все предметы</span
          >
        </div>
        <div class="items__headSearch">
          <img src="../../assets/images/search.svg" />
          <input
            type="text"
            placeholder="Llama, Cat..."
            v-model="filterInput"
            @input="filterPets"
          />
        </div>
      </div>
      <div class="items__basket" @click="openCarts" v-if="isPermissions.manage_user_items">
        <img src="../../assets/images/basket.svg" />
        <span
          class="items__basket__count"
          v-if="selectedItems.length || selectedGiveItems.length"
          >{{ countSelectedItems }}</span
        >
      </div>
    </div>
    <div class="items__content" v-if="itemsFind">
      <div class="filtermenu">
        <div class="filtermenu__block">
          <div class="filtermenu__block__closed" @click="openedFilters.type = !openedFilters.type">
            <h2>
              Тип <span>({{ getSelectedTypesCount() > 0 ? getSelectedTypesCount() : 'Все' }})</span>
            </h2>
            <img
              src="../../assets/images/down-arrow.svg"
              :class="{ opened: openedFilters.type }"
              alt="open"
            />
          </div>
          <div class="filtermenu__types" v-if="openedFilters.type">
            <div v-for="type in itemTypes" :key="type.key" class="filtermenu__types__type">
              <div class="filtermenu__types__type__wrapper">
                <div class="custom-checkbox">
                  <input
                    type="checkbox"
                    :id="`id-${type.key}-inventory`"
                    v-model="filters.types[type.key]"
                  />
                  <label @click="toggleType(type)" :for="`id-${type.key}-inventory`"></label>
                </div>
                <label @click="toggleType(type)" class="name" :for="`id-${type.key}-inventory`">{{
                  type.text
                }}</label>
              </div>
              <div v-if="filters.types[type.key]" class="filtermenu__types__type__wrapper__subtype">
                <div
                  v-for="subtype in type.subtypes"
                  :key="subtype.key"
                  class="filtermenu__types__type"
                >
                  <div class="filtermenu__types__type__wrapper subtype">
                    <div class="custom-checkbox">
                      <input
                        type="checkbox"
                        :id="`id-${subtype.key}-inventory`"
                        v-model="filters.subtypes[type.key][subtype.key]"
                      />
                      <label
                        @click="checkAllSubTypesForType(type)"
                        :for="`id-${subtype.key}-inventory`"
                      ></label>
                    </div>
                    <label
                      @click="checkAllSubTypesForType(type)"
                      class="name"
                      :for="`id-${subtype.key}-inventory`"
                      >{{ subtype.text }}</label
                    >
                  </div>
                </div>
              </div>
            </div>

            <small v-if="getSelectedTypesCount() > 0" class="filtermenu__reset" @click="resetTypes">
              Сбросить
            </small>
          </div>
        </div>

        <div class="filtermenu__block">
          <div
            class="filtermenu__block__closed"
            @click="openedFilters.rarity = !openedFilters.rarity"
          >
            <h2 class="filtermenu__header">
              Редкость
              <span
                >({{ getSelectedRaritiesCount() > 0 ? getSelectedRaritiesCount() : 'Все' }})</span
              >
            </h2>
            <img
              src="../../assets/images/down-arrow.svg"
              :class="{ opened: openedFilters.rarity }"
              alt="open"
            />
          </div>
          <div v-if="openedFilters.rarity" class="filtermenu__rarities">
            <div
              v-for="rarity in allRarities"
              :key="rarity.key"
              class="filtermenu__rarities__rarity"
              :class="[rarity.key, { active: filters.rarities[rarity.key] }]"
              @click="toggleRarity(rarity)"
            >
              <p>{{ rarity.text }}</p>
            </div>
          </div>
          <small
            v-if="getSelectedRaritiesCount() > 0 && openedFilters.rarity"
            class="filtermenu__reset"
            @click="resetRarities"
          >
            Сбросить
          </small>
        </div>

        <div class="filtermenu__block">
          <div
            class="filtermenu__block__closed"
            @click="openedFilters.properties = !openedFilters.properties"
          >
            <h2 class="filtermenu__header">
              Свойства
              <span
                >({{
                  getSelectedPropertiesCount() > 0 ? getSelectedPropertiesCount() : 'Все'
                }})</span
              >
            </h2>
            <img
              src="../../assets/images/down-arrow.svg"
              :class="{ opened: openedFilters.rarity }"
              alt="open"
            />
          </div>

          <div class="filtermenu__types" v-if="openedFilters.properties">
            <div
              v-for="property in itemProperties"
              :key="property.key"
              class="filtermenu__types__type"
            >
              <div class="filtermenu__types__type__wrapper">
                <div class="custom-checkbox">
                  <input
                    type="checkbox"
                    :id="`id-${property.key}-inventory`"
                    v-model="filters.properties[property.key]"
                  />
                  <label
                    @click="toggleFilters(property.key)"
                    :for="`id-${property.key}-inventory`"
                  ></label>
                </div>
                <label
                  @click="toggleFilters(property.key)"
                  :for="`id-${property.key}-inventory`"
                  class="name"
                >
                  <img :src="require(`../../assets/images/${property.key}.svg`)" />
                  {{ property.text }}
                </label>
              </div>
            </div>
            <small
              v-if="getSelectedPropertiesCount() > 0"
              class="filtermenu__reset"
              @click="resetProperties"
            >
              Сбросить
            </small>
          </div>
        </div>

        <div class="filtermenu__block">
          <div
            class="filtermenu__block__closed"
            @click="openedFilters.level = !openedFilters.level"
          >
            <h2 class="filtermenu__header">
              Уровень
              <span>({{ getSelectedAgesCount() > 0 ? getSelectedAgesCount() : 'Все' }})</span>
            </h2>
            <img
              src="../../assets/images/down-arrow.svg"
              :class="{ opened: openedFilters.level }"
              alt="open"
            />
          </div>

          <div class="filtermenu__types" v-if="openedFilters.level">
            <div v-for="level in allLevels" :key="level.key" class="filtermenu__types__type">
              <div class="filtermenu__types__type__wrapper">
                <div class="custom-checkbox">
                  <input
                    type="checkbox"
                    :id="`id-${level.key}-inventory`"
                    v-model="filters.levels[level.key]"
                  />
                  <label @click="toggleLevel(level)" :for="`id-${level.key}-inventory`"></label>
                </div>
                <label @click="toggleLevel(level)" :for="`id-${level.key}-inventory`" class="name">
                  <img :src="require(`../../assets/images/${level.key}.svg`)" />
                  {{ level.text }}
                </label>
              </div>

              <div
                v-if="filters.levels[level.key]"
                class="filtermenu__types__type__wrapper__subtype"
              >
                <div v-for="age in level.ages" :key="age.key" class="filtermenu__types__type">
                  <div class="filtermenu__types__type__wrapper subtype">
                    <div class="custom-checkbox">
                      <input
                        type="checkbox"
                        :id="`id-${age.key}`"
                        v-model="filters.ages[age.key]"
                      />
                      <label @click="checkAllAgesForLevel(level)" :for="`id-${age.key}`"></label>
                    </div>
                    <label @click="checkAllAgesForLevel(level)" :for="`id-${age.key}`" class="name">
                      {{ age.text }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!--                                <small-->
            <!--                                        v-if="getSelectedAgesCount() > 0"-->
            <!--                                        class="filtermenu__reset"-->
            <!--                                        @click="resetLevels"-->
            <!--                                >-->
            <!--                                    Сбросить-->
            <!--                                </small>-->
          </div>
        </div>
      </div>
      <div class="items__inventory__wrapper">
        <div class="pettable">
          <div
            class="pettable__pet pet"
            v-for="pet in filtredItems"
            @click="withdrawPet(pet)"
            :class="[
              pet.selected ? 'selectedPet' : '',
              petsInfo[pet.id].rare,
              pet.onSale ? 'sale' : '',
              pet.onWithdrawal ? 'withdrawItem' : '',
              disableWithdrawBtn ? 'disable' : ''
            ]"
          >
            <div class="pet__sale" v-if="pet.onSale">
              <img src="../../assets/images/pet/saleItem.svg" />
            </div>
            <div class="pet__sale" v-if="pet.onWithdrawal">
              <img src="../../assets/images/pet/withdrawItem.png" />
            </div>
            <p class="pet__saleId" v-if="pet.onSale">{{ pet.saleId }}</p>
            <div class="pet__hover">
              <div class="pet__hover__add">
                <img src="../../assets/images/pet/addPet.svg" />
              </div>
            </div>
            <div class="pet__addition">
              <span class="M" v-if="petsInfo[pet.id].type === 'mega_neon'">M</span>
              <span class="N" v-if="petsInfo[pet.id].type === 'neon'">N</span>
              <span class="F" v-if="petsInfo[pet.id].flyable">F</span>
              <span class="R" v-if="petsInfo[pet.id].rideable">R</span>
            </div>
            <div class="pet__image">
              <img :src="petsInfo[pet.id].imageUri" />
            </div>
            <div class="pet__info">
              <h3>{{ petsInfo[pet.id].name }}</h3>
              <h4>{{ petsInfo[pet.id].age }}</h4>
              <p v-if="pet.count">{{ pet.count }} шт</p>
            </div>
          </div>
          <div
            class="pettable__pet pet"
            v-for="pet in filtredAllGiveItems"
            @click="selectGivePet(pet)"
            :class="[pet.rare]"
          >
            <div class="pet__hover">
              <div class="pet__hover__add">
                <img src="../../assets/images/pet/addPet.svg" />
              </div>
            </div>
            <div class="pet__addition">
              <span class="M" v-if="pet.type === 'mega_neon'">M</span>
              <span class="N" v-if="pet.type === 'neon'">N</span>
              <span class="F" v-if="pet.flyable">F</span>
              <span class="R" v-if="pet.rideable">R</span>
            </div>
            <div class="pet__image">
              <img :src="pet.imageUri" />
            </div>
            <div class="pet__info">
              <h3>{{ pet.name }}</h3>
              <h4>{{ pet.age }}</h4>
            </div>
          </div>
        </div>
        <!--                        <div v-if="showGiveItems.length" class="pettable__loadMore">-->
        <!--                            <button @click="loadMoreGiveItems">Загрузить еще</button>-->
        <!--                        </div>-->
      </div>
      <div class="items-cart" v-if="openCart">
        <div class="items-cart__header">
          <h2>Количество</h2>
          <p>{{ countSelectedItems }} предметов</p>
          <img src="../../assets/images/close.svg" @click="openCarts" />
        </div>
        <div
          class="items-cart__pets"
          :class="{ no__items: !selectedItems.length && !selectedGiveItems.length }"
        >
          <p
            class="items-cart__pets_noItems"
            v-if="!selectedItems.length && !selectedGiveItems.length"
          >
            Вы ещё не добавили ни одного предмета в корзину
          </p>
          <div
            class="items-cart__pets__item"
            v-for="(pet, index) in selectedItems"
            :class="petsInfo[pet.id].rare"
          >
            <div class="cart__addition">
              <span class="M" v-if="petsInfo[pet.id].type === 'mega_neon'">M</span>
              <span class="N" v-if="petsInfo[pet.id].type === 'neon'">N</span>
              <span class="F" v-if="petsInfo[pet.id].flyable">F</span>
              <span class="R" v-if="petsInfo[pet.id].rideable">R</span>
            </div>
            <div class="cart__img">
              <img :src="petsInfo[pet.id].imageUri" />
            </div>
            <div class="info">
              <p>{{ petsInfo[pet.id].name }}</p>
              <span>{{ petsInfo[pet.id].age }}</span>
            </div>
            <div class="cart__items__count">
              <span
                class="cart__items__count__minus"
                @click="decreasePet(pet, index)"
                :class="{ disable: disableWithdrawBtn }"
                >-</span
              >
              <div class="cart__items__count__value">{{ pet.count }}</div>
            </div>
            <div
              class="delete"
              @click="withdrawPetDelete(pet, index)"
              :class="{ disable: disableWithdrawBtn }"
            >
              <img src="../../assets/images/delete.svg" />
            </div>
          </div>
          <div
            class="items-cart__pets__item"
            v-for="(pet, index) in selectedGiveItems"
            :class="pet.rare"
          >
            <div class="cart__addition">
              <span class="M" v-if="pet.type === 'mega_neon'">M</span>
              <span class="N" v-if="pet.type === 'neon'">N</span>
              <span class="F" v-if="pet.flyable">F</span>
              <span class="R" v-if="pet.rideable">R</span>
            </div>
            <div class="cart__img">
              <img :src="pet.imageUri" />
            </div>
            <div class="info">
              <p>{{ pet.name }}</p>
              <span>{{ pet.age }}</span>
            </div>
            <div class="cart__items__count">
              <span
                class="cart__items__count__minus"
                @click="decreasePet(pet, index)"
                :class="{ disable: disableWithdrawBtn }"
                >-</span
              >
              <div class="cart__items__count__value">{{ pet.count }}</div>
            </div>
            <div
              class="delete"
              @click="withdrawPetDelete(pet, index)"
              :class="{ disable: disableWithdrawBtn }"
            >
              <img src="../../assets/images/delete.svg" />
            </div>
          </div>
        </div>
        <div class="items-cart__input" v-if="selectedItems.length && selected === selectItems[0]">
          <input type="text" placeholder="User Id кому передать" v-model="sendToUserId" />
        </div>
        <div class="items-cart__input" v-if="selectedItems.length || selectedGiveItems.length">
          <input type="text" placeholder="Two-factor" v-model="twoFactor" />
        </div>
        <div
          class="items-cart__input"
          v-if="
            (selectedItems.length || selectedGiveItems.length) &&
            (selected === selectItems[2] || selected === selectItems[1])
          "
        >
          <input type="text" placeholder="botTarget" v-model="botTarget" />
        </div>
        <button
          class="items-cart__accept"
          :class="[twoFactor.length && !this.disableWithdrawBtn ? '' : 'disable']"
          v-if="selectedItems.length || selectedGiveItems.length"
          @click="withdrawPets"
        >
          Подтвердить
        </button>
        <p class="items-cart__pets__success" v-if="withdrawSuccess">Успешно</p>
        <p class="errorMsg" v-if="errorWithdrawMsg">{{ this.errorWithdrawMsg }}</p>
        <div class="withdrawLoader" v-if="disableWithdrawBtn">
          <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import http from '../../utils/http'
import cookie from 'vue-cookie'
import filtersContants from '../../constants/filters.js'

import Loader from '../../components/Loader/Loader'

import './items.scss'

export default {
  name: 'Items',
  components: {
    Loader
  },
  data() {
    return {
      selectOpen: false,
      selected: 'Выберете действие',
      selectItems: ['Передать', 'Забрать', 'Выдать'],
      userId: '',
      disableBtn: false,
      errorMsg: false,
      itemsFind: false,
      items: [],
      idList: [],
      countItems: {},
      petsInfo: {},
      initialItems: [],
      finalItems: [],
      itemTypes: filtersContants.ITEM_TYPES,
      openedFilters: {
        type: false,
        rarity: false,
        properties: false,
        level: false
      },
      filters: JSON.parse(JSON.stringify(filtersContants.DEFAULT_FILTERS)),
      allRarities: filtersContants.ALL_RARITIES,
      itemProperties: filtersContants.ITEM_PROPERTIES,
      allLevels: filtersContants.ALL_LEVELS,
      filterInput: '',
      openCart: false,
      loader: false,
      selectedItems: [],
      selectedGiveItems: [],
      twoFactor: '',
      botTarget: '',
      sendToUserId: '',
      countSelectedItems: 0,
      errorWithdrawMsg: '',
      errorsWithdrawMessages: {
        1: 'Ошибка с доступом',
        2: 'Лимит вывода превышен',
        3: 'Ошибка двухфакторная аутентификация'
      },
      allGiveItems: [],
      searchAllGiveItems: [],
      withdrawSuccess: false,
      disableWithdrawBtn: false,
      selectAll: false
    }
  },
  computed: {
    isPermissions() {
      return this.$store.state.permissions
    },
    filtredItems() {
      return this.finalItems.filter((i) => this.filterItem(i))
    },
    filtredAllGiveItems() {
      return this.searchAllGiveItems.filter((i) => this.filterGiveItem(i)).slice(0, 150)
    }
  },
  created() {},
  destroyed() {},
  methods: {
    filterItem(item) {
      if (!this.filterByType(item)) {
        return false
      }

      if (!this.filterByRarity(item, this.filters)) {
        return false
      }

      if (
        !this.filterByProperty(item, this.filters) ||
        !this.filterByAge(item, this.filters) ||
        !this.filterByLevel(item, this.filters)
      ) {
        return false
      }

      return true
    },
    filterGiveItem(pet) {
      if (!this.filterByTypeGiveItem(pet)) {
        return false
      }

      if (!this.filterGiveItemByRarity(pet, this.filters)) {
        return false
      }

      if (
        !this.filterGiveItemByProperty(pet, this.filters) ||
        !this.filterGiveItemByAge(pet, this.filters) ||
        !this.filterGiveItemByLevel(pet, this.filters)
      ) {
        return false
      }

      return true
    },
    filterByType(item) {
      if (!Object.keys(this.filters.types).find((t) => this.filters.types[t])) {
        return true
      }

      const type = this.petsInfo[item.id].itemType

      return this.filters.types[type]
    },
    filterByTypeGiveItem(pet) {
      if (!Object.keys(this.filters.types).find((t) => this.filters.types[t])) {
        return true
      }

      const type = pet.itemType

      return this.filters.types[type]
    },
    filterByRarity(item, filters) {
      if (!Object.keys(filters.rarities).find((r) => filters.rarities[r])) {
        return true
      }

      return filters.rarities[this.petsInfo[item.id].rare]
    },
    filterGiveItemByRarity(pet, filters) {
      if (!Object.keys(filters.rarities).find((r) => filters.rarities[r])) {
        return true
      }

      return filters.rarities[pet.rare]
    },
    filterByProperty(item, filters) {
      if (!Object.keys(filters.properties).find((p) => filters.properties[p])) {
        return true
      }

      if (filters.properties.flyable && filters.properties.rideable) {
        return this.petsInfo[item.id].flyable && this.petsInfo[item.id].rideable
      }

      if (
        filters.properties.flyable &&
        this.petsInfo[item.id].flyable &&
        !this.petsInfo[item.id].rideable
      ) {
        return true
      }

      if (
        filters.properties.rideable &&
        this.petsInfo[item.id].rideable &&
        !this.petsInfo[item.id].flyable
      ) {
        return true
      }

      if (
        filters.properties.missing &&
        !this.petsInfo[item.id].flyable &&
        !this.petsInfo[item.id].rideable
      ) {
        return true
      }
    },
    filterGiveItemByProperty(pet, filters) {
      if (!Object.keys(filters.properties).find((p) => filters.properties[p])) {
        return true
      }

      if (filters.properties.flyable && filters.properties.rideable) {
        return pet.flyable && pet.rideable
      }

      if (filters.properties.flyable && pet.flyable && !pet.rideable) {
        return true
      }

      if (filters.properties.rideable && pet.rideable && !pet.flyable) {
        return true
      }

      if (filters.properties.missing && !pet.flyable && !pet.rideable) {
        return true
      }
    },
    filterByAge(item, filters) {
      if (!Object.keys(filters.ages).find((a) => filters.ages[a])) {
        return true
      }

      return filters.ages[this.petsInfo[item.id].age]
    },
    filterGiveItemByAge(pet, filters) {
      if (!Object.keys(filters.ages).find((a) => filters.ages[a])) {
        return true
      }

      return filters.ages[pet.age]
    },
    filterByLevel(item, filters) {
      if (!Object.keys(filters.levels).find((l) => filters.levels[l])) {
        return true
      }

      return filters.levels[this.petsInfo[item.id].type]
    },
    filterGiveItemByLevel(pet, filters) {
      if (!Object.keys(filters.levels).find((l) => filters.levels[l])) {
        return true
      }

      return filters.levels[pet.type]
    },
    openSelectAction() {
      this.selectOpen = !this.selectOpen
    },
    selectedAction(action) {
      this.selected = action
      this.selectOpen = !this.selectOpen
    },
    openCarts() {
      this.openCart = !this.openCart
    },
    computeFinalItems(array) {
      for (const pet of array) {
        if (!this.countItems[pet.goodId]) {
          this.countItems[pet.goodId] = {
            onSale: [],
            uniqueIds: [],
            onWithdrawal: 0,
            count: 0
          }
        }

        if (pet.onSale) {
          this.countItems[pet.goodId].onSale.push(pet.saleId)
        }

        if (pet.onWithdrawal) {
          this.countItems[pet.goodId].onWithdrawal++
        }

        if (!pet.onWithdrawal && !pet.onSale) {
          this.countItems[pet.goodId].uniqueIds.push(pet.uniqueId)
          this.countItems[pet.goodId].count++
        }
      }

      for (const key in this.countItems) {
        if (this.countItems[key].count) {
          this.finalItems.push({
            id: key,
            count: this.countItems[key].count,
            uniqueIds: this.countItems[key].uniqueIds
          })
        }

        if (this.countItems[key].onSale.length) {
          for (let i = 0; i < this.countItems[key].onSale.length; i++) {
            this.finalItems.push({ id: key, onSale: true, saleId: this.countItems[key].onSale[i] })
          }
        }

        if (this.countItems[key].onWithdrawal) {
          for (let i = 0; i < this.countItems[key].onWithdrawal; i++) {
            this.finalItems.push({ id: key, onWithdrawal: true })
          }
        }
      }
      this.initialItems = this.finalItems
    },
    getPetsInfo(array) {
      for (const petInfo of array) {
        this.petsInfo[petInfo.id] = {
          age: petInfo.age,
          flyable: petInfo.flyable,
          imageUri: petInfo.imageUri,
          name: petInfo.name,
          rare: petInfo.rare,
          rideable: petInfo.rideable,
          type: petInfo.type,
          itemType: petInfo.itemType
        }
      }
    },
    async findUserInventory() {
      this.disableBtn = true
      this.loader = true
      const response = await http.get(
        `https://items.neuralgeneration.com/api/items/?userId=${this.userId}`,
        {
          Authorization: `Bearer ${this.$store.state.tokens.access}`
        }
      )
      if (response.statusCode === 200) {
        this.items = response.data.items
        this.computeFinalItems(this.items)
        this.idList = this.items.map((item) => {
          return item.goodId
        })
        this.byIdList()
      } else {
        this.errorMsg = true
        setTimeout(() => {
          this.errorMsg = false
        }, 2000)
        this.loader = false
        this.userId = ''
        this.disableBtn = false
      }
    },
    async byIdList() {
      const response = await http.post(
        `https://goods.neuralgeneration.com/api/goods/fetch_by_id_list`,
        {
          idList: this.idList
        },
        cookie.get('token')
      )
      if (response.statusCode === 200) {
        this.getPetsInfo(response.data.goods)
        this.itemsFind = true
      } else {
        this.errorMsg = true
        setTimeout(() => {
          this.errorMsg = false
        }, 2000)
      }
      this.loader = false
      this.disableBtn = false
    },
    async findAllItems() {
      this.disableBtn = true
      this.loader = true
      const responsePet = await http.get(
        'https://goods.neuralgeneration.com/api/goods/fetch_by_type?type=pet'
      )
      const responsePotion = await http.get(
        'https://goods.neuralgeneration.com/api/goods/fetch_by_type?type=potion'
      )
      const responseEgg = await http.get(
        'https://goods.neuralgeneration.com/api/goods/fetch_by_type?type=egg'
      )
      const responseTransport = await http.get(
        'https://goods.neuralgeneration.com/api/goods/fetch_by_type?type=transport'
      )
      if (
        responsePet.statusCode === 200 &&
        responsePotion.statusCode === 200 &&
        responseEgg.statusCode === 200 &&
        responseTransport.statusCode === 200
      ) {
        this.allGiveItems = [].concat(
          responsePet.data.goods,
          responsePotion.data.goods,
          responseEgg.data.goods,
          responseTransport.data.goods
        )
        this.searchAllGiveItems = this.allGiveItems
        this.itemsFind = true
      } else {
        this.errorMsg = true
        setTimeout(() => {
          this.errorMsg = false
        }, 2000)
        this.userId = ''
      }
      this.loader = false
      this.disableBtn = false
    },
    // loadMoreGiveItems () {
    //     this.showGiveItems = this.showGiveItems.concat(this.allGiveItems.slice(this.showGiveItems.length, this.showGiveItems.length + 100))
    // },
    backToFind() {
      this.openCart = false
      this.filterInput = ''
      this.initialItems = []
      this.finalItems = []
      this.searchAllGiveItems = []
      this.countItems = {}
      this.selectedItems = []
      this.allGiveItems = []
      this.selectedGiveItems = []
      this.countSelectedItems = 0
      this.itemsFind = false
      this.userId = ''
      this.selected = 'Выберете действие'
      this.selectAll = false
    },
    filterPets() {
      if (this.selected === this.selectItems[2]) {
        this.searchAllGiveItems = this.allGiveItems.filter((pet) => {
          return (
            pet.name.toLowerCase().includes(this.filterInput.toLowerCase()) ||
            pet.id.includes(this.filterInput)
          )
        })
      } else {
        this.finalItems = this.initialItems.filter((pet) => {
          return this.petsInfo[pet.id].name.toLowerCase().includes(this.filterInput.toLowerCase())
        })
      }
    },
    toggleType(type) {
      setTimeout(() => {
        if (type.subtypes) {
          type.subtypes.forEach((subtype) => {
            this.filters.subtypes[type.key][subtype.key] = this.filters.types[type.key]
          })
        }
      }, 1)
    },
    toggleRarity(rarity) {
      this.filters.rarities[rarity.key] = !this.filters.rarities[rarity.key]
    },
    toggleFilters(filterName) {
      this.filters[filterName] = this.filters[filterName]
    },
    toggleLevel(level) {
      setTimeout(() => {
        if (level.ages) {
          level.ages.forEach((age) => {
            this.filters.ages[age.key] = this.filters.levels[level.key]
          })
        }
      }, 1)
    },
    getSelectedTypesCount() {
      let count = 0

      this.itemTypes.forEach((type) => {
        count += this.filters.types[type.key] ? 1 : 0
      })

      return count
    },
    getSelectedRaritiesCount() {
      let count = 0

      this.allRarities.forEach((prop) => {
        count += this.filters.rarities[prop.key] ? 1 : 0
      })

      return count
    },
    getSelectedPropertiesCount() {
      let count = 0

      this.itemProperties.forEach((prop) => {
        count += this.filters.properties[prop.key] ? 1 : 0
      })

      return count
    },
    getSelectedAgesCount() {
      let count = 0

      this.allLevels.forEach((level) => {
        count += this.filters.levels[level.key] ? 1 : 0
      })

      return count
    },
    checkAllSubTypesForType(type) {
      setTimeout(() => {
        const checked = Object.keys(this.filters.subtypes[type.key]).find(
          (subtype) => this.filters.subtypes[type.key][subtype]
        )

        if (!checked) {
          this.filters.types[type.key] = false
        }
      }, 1)
    },
    checkAllAgesForLevel(level) {
      setTimeout(() => {
        const checked = level.ages.find((age) => this.filters.ages[age.key])

        if (!checked) {
          this.filters.levels[level.key] = false
        }
      }, 1)
    },
    resetTypes() {
      Object.keys(this.filters.types).forEach((key) => {
        this.filters.types[key] = false
      })
    },
    resetRarities() {
      Object.keys(this.filters.rarities).forEach((key) => {
        this.filters.rarities[key] = false
      })
    },
    resetProperties() {
      Object.keys(this.filters.properties).forEach((key) => {
        this.filters.properties[key] = false
      })
    },
    // resetLevels () {
    //     Object.keys(this.filters.levels).forEach((key) => {
    //         this.filters.levels[key] = false
    //     })
    // },
    withdrawPet(obj) {
      obj.count--
      const selectPet = {
        count: 1,
        id: obj.id,
        uniqueIds: []
      }
      let foundItem = false
      for (const pet of this.selectedItems) {
        if (pet.id === obj.id) {
          foundItem = true
          pet.count++
          pet.uniqueIds.push(obj.uniqueIds.shift())
        }
      }
      if (!foundItem) {
        selectPet.uniqueIds.push(obj.uniqueIds.shift())
        this.selectedItems.push(selectPet)
      }
      if (!obj.count) {
        obj.selected = true
      }
      this.counterSelectedPets()
    },
    selectGivePet(obj) {
      let foundItem = false
      for (const pet of this.selectedGiveItems) {
        if (pet.id === obj.id) {
          foundItem = true
          pet.count++
        }
      }
      if (!foundItem) {
        obj.count = 1
        this.selectedGiveItems.push(obj)
      }
      this.counterSelectedPets()
    },
    decreasePet(obj, index) {
      obj.count--
      if (this.selected === this.selectItems[2]) {
        if (!obj.count) {
          this.selectedGiveItems.splice(index, 1)
        }
      } else {
        if (!obj.count) {
          this.selectedItems.splice(index, 1)
        }

        for (const pet of this.finalItems) {
          if (pet.id === obj.id && !pet.onSale) {
            pet.count++
            pet.uniqueIds.unshift(obj.uniqueIds.shift())
            pet.selected = false
          }
        }
      }
      this.counterSelectedPets()
    },
    withdrawPetDelete(obj, index) {
      if (this.selected === this.selectItems[2]) {
        this.selectedGiveItems.splice(index, 1)
      } else {
        this.selectedItems.splice(index, 1)
        for (const pet of this.finalItems) {
          if (pet.id === obj.id && !pet.onSale) {
            pet.count += obj.count
            pet.selected = false
            pet.uniqueIds.push(...obj.uniqueIds)
          }
        }
      }
      this.counterSelectedPets()
    },
    counterSelectedPets() {
      this.countSelectedItems = 0
      this.selectedItems.map((pet) => {
        this.countSelectedItems += pet.count
      })
      this.selectedGiveItems.map((pet) => {
        this.countSelectedItems += pet.count
      })
    },
    selectedPetsUniqueIds() {
      return this.selectedItems.reduce((acc, cur) => {
        acc = acc.concat(cur.uniqueIds)
        return acc
      }, [])
    },
    selectedPetsGoodIds() {
      const goodIds = []
      if (this.selected === this.selectItems[2]) {
        for (let pet of this.selectedGiveItems) {
          for (let i = 0; i < pet.count; i++) {
            goodIds.push(pet.id)
          }
        }
      } else {
        for (let pet of this.selectedItems) {
          for (let i = 0; i < pet.count; i++) {
            goodIds.push(pet.id)
          }
        }
      }
      return goodIds
    },
    selectedActionToFetch() {
      if (this.selected === this.selectItems[0]) {
        return 'exchange'
      }

      if (this.selected === this.selectItems[1]) {
        return 'take'
      }

      if (this.selected === this.selectItems[2]) {
        return 'give'
      }
    },
    targetToFetch() {
      if (this.selected === this.selectItems[0]) {
        return this.sendToUserId
      } else {
        return this.userId
      }
    },
    getItemsInfo() {
      fetch(`https://auth.apineural.com/api/user/admin-items-info`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${this.$store.state.tokens.access}`
        }
      })
        .then((res) => res.json())
        .then((data) => {
          const wastedItems = data.wasted.toFixed(2)
          this.$store.commit('setWastedLimitItems', wastedItems)
        })
    },
    async withdrawPets() {
      this.disableWithdrawBtn = true
      const body = {
        action: this.selectedActionToFetch(),
        uniqueIds: this.selectedPetsUniqueIds(),
        target: this.targetToFetch(),
        code: this.twoFactor,
        goodIds: this.selectedPetsGoodIds()
      }
      if (
        (this.selected === this.selectItems[2] || this.selected === this.selectItems[1]) &&
        this.botTarget.length
      ) {
        body.botTarget = this.botTarget
      }

      const response = await http.post(
        `https://auth.apineural.com/api/user/admin-items`,
        body,
        cookie.get('token')
      )
      if (response.statusCode === 200) {
        this.selectedItems = []
        this.selectedGiveItems = []
        this.countSelectedItems = 0
        this.sendToUserId = ''
        this.twoFactor = ''
        this.withdrawSuccess = true
        this.getItemsInfo()
        setTimeout(() => {
          this.withdrawSuccess = false
        }, 1500)
      } else {
        this.errorWithdrawMsg = this.errorsWithdrawMessages[response.data.errorCode]
        this.twoFactor = ''
        setTimeout(() => {
          this.errorWithdrawMsg = ''
        }, 1500)
      }
      this.disableWithdrawBtn = false
    },
    selectAllCheckbox() {
      if (!this.selectAll) {
        for (let pet of this.finalItems) {
          if (pet.count) {
            this.selectedItems.push({ ...pet })
            pet.selected = true
            pet.count = 0
          }
        }
      } else {
        this.selectedItems.forEach((selectedItem) => {
          const index = this.finalItems.findIndex((item) => {
            return item.id === selectedItem.id
          })

          if (index !== -1) {
            this.$set(this.finalItems, index, {
              ...this.finalItems[index],
              selected: false,
              count: (this.finalItems[index].count || 0) + (selectedItem.count || 0)
            })
          }
        })

        this.selectedItems = []
      }
      this.selectAll = !this.selectAll
      this.counterSelectedPets()
    }
  }
}
</script>
